"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _solarReact = require("@solar/solar-react");

var _FabricateForm = _interopRequireDefault(require("../Fabricate/FabricateForm"));

var _ProductTypeSelector = _interopRequireDefault(require("../Product/ProductTypeSelector"));

var _useProductData = require("../Product/useProductData");

var _Alert = _interopRequireDefault(require("../Alert"));

var _TodoMessage = _interopRequireDefault(require("../TodoMessage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '90vw',
      maxWidth: 1024
    },
    formControl: {
      width: '100%'
    }
  };
});

var CreateFabricateDialog = function CreateFabricateDialog(_ref) {
  var types = _ref.types,
      product = _ref.product,
      createFabricate = _ref.createFabricate,
      labels = _ref.labels,
      open = _ref.open,
      onClose = _ref.onClose;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      formValid = _useState2[0],
      setFormValid = _useState2[1]; // typeSelector, form


  var typeSelectionPossible = product.types.length > 1;

  var _useState3 = (0, _react.useState)(typeSelectionPossible ? 'typeSelector' : 'form'),
      _useState4 = _slicedToArray(_useState3, 2),
      view = _useState4[0],
      setView = _useState4[1];

  var _useState5 = (0, _react.useState)('single'),
      _useState6 = _slicedToArray(_useState5, 2),
      mode = _useState6[0],
      setMode = _useState6[1];

  var _useState7 = (0, _react.useState)(5),
      _useState8 = _slicedToArray(_useState7, 2),
      multiAmount = _useState8[0],
      setMultiAmount = _useState8[1];

  var multiple = mode !== 'single';

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedType = _useState10[0],
      setSelectedType = _useState10[1];

  var _usePublishedProductD = (0, _useProductData.usePublishedProductData)(product, selectedType),
      formJSON = _usePublishedProductD.formJSON,
      formUIJSON = _usePublishedProductD.formUIJSON; // does the certificate have multiple types assigned


  var showWarning = selectedType && !types.includes(selectedType);

  var _useState11 = (0, _react.useState)({}),
      _useState12 = _slicedToArray(_useState11, 2),
      data = _useState12[0],
      setData = _useState12[1];

  var closeDialog = function closeDialog() {
    setData({});
    onClose();
  };

  return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    open: open,
    onClose: closeDialog,
    classes: {
      paper: classes.root
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.DialogTitle, null, multiple ? labels.create.titleMultiple : labels.create.title, selectedType ? ": ".concat(product.types.find(function (_ref2) {
    var key = _ref2.key;
    return key === selectedType;
  }).title) : ''), /*#__PURE__*/_react["default"].createElement(_core.DialogContent, null, view === 'typeSelector' && /*#__PURE__*/_react["default"].createElement(_ProductTypeSelector["default"], {
    types: product.types,
    value: selectedType,
    onChange: function onChange(event) {
      setSelectedType(event.target.value);
    }
  }), view === 'typeSelector' && showWarning && /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    title: 'Je selecteerde een ProductType die (nog) niet werd gecertificeerd',
    variant: "warning",
    message: 'U kan fabrikaten aanmaken voor dit ProductType, maar weet dat de fabrikaten pas zullen worden gepubliceerd wanneer dit product type in uw certificaat wordt opgenomen.'
  }), view === 'typeSelector' && !!selectedType && /*#__PURE__*/_react["default"].createElement(_core.FormControl, {
    className: classes.formControl
  }, /*#__PURE__*/_react["default"].createElement(_core.RadioGroup, {
    "aria-label": "Select mode",
    name: "mode",
    className: classes.group,
    value: mode,
    onChange: function onChange(event) {
      setMode(event.target.value);
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
    value: 'single',
    control: /*#__PURE__*/_react["default"].createElement(_core.Radio, null),
    label: 'maak een enkel fabrikaat aan'
  }), /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
    value: 'import',
    control: /*#__PURE__*/_react["default"].createElement(_core.Radio, null),
    label: 'importeer een CSV met meerdere fabrikatem'
  }), /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
    value: 'multiple',
    control: /*#__PURE__*/_react["default"].createElement(_core.Radio, null),
    label: 'maak meerdere fabrikaten aan'
  }))), view === 'typeSelector' && !!selectedType && mode === 'multiple' && /*#__PURE__*/_react["default"].createElement(_core.FormControl, null, /*#__PURE__*/_react["default"].createElement(_core.TextField, {
    type: "number",
    value: multiAmount,
    onChange: function onChange(ev) {
      console.log(ev.target.value);
      setMultiAmount(parseInt(ev.target.value, 10));
    }
  })), view === 'form' && mode !== 'import' && /*#__PURE__*/_react["default"].createElement(_FabricateForm["default"], {
    data: data,
    formJSON: formJSON,
    formUIJSON: formUIJSON,
    onChange: function onChange(_ref3) {
      var errors = _ref3.errors,
          d = _ref3.data;
      setFormValid(errors.length === 0);
      setData(d);
    }
  }), view === 'form' && mode === 'import' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.List, null, /*#__PURE__*/_react["default"].createElement(_solarReact.FileListItem, {
    label: 'Download an exampe CSV',
    fileUrl: 'example.csv',
    interactive: true,
    onClickOpen: function onClickOpen() {},
    onClickDownloadFile: function onClickDownloadFile() {}
  })), /*#__PURE__*/_react["default"].createElement(_TodoMessage["default"], {
    message: "Todo: map fields"
  }))), /*#__PURE__*/_react["default"].createElement(_core.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: closeDialog
  }, labels.cancel), typeSelectionPossible && /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    color: "primary",
    onClick: function onClick() {
      setView('typeSelector');
    },
    disabled: view === 'typeSelector'
  }, "prev"), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    color: "primary",
    onClick: function onClick() {
      setView('form');
    },
    disabled: view === 'form' || !selectedType
  }, "next")), view === 'form' && /*#__PURE__*/_react["default"].createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      createFabricate({
        data: data,
        isValid: formValid
      }, mode === 'multiple' ? multiAmount : 1);
      closeDialog();
    },
    disabled: view !== 'form'
  }, labels.create.action[mode])));
};

var _default = CreateFabricateDialog;
exports["default"] = _default;